<div>
  <div class="min-page-height">
    <app-topnavigation></app-topnavigation>
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
    <app-footer></app-footer>
</div>